export default function (formatMessage: Function) {
  return {
    brandChannelOptions: [
      {
        value: "KKSolutionsOrProductsNotFound",
        label: formatMessage({
          id: "KKSolutionsOrProductsNotFound",
          defaultMessage: "Prodotto o soluzione non presente",
        }),
      },
      {
        value: "OtherBrand",
        label: formatMessage({
          id: "OtherBrand",
          defaultMessage: "Utilizzo di un altro brand",
        }),
      },
    ],
    brandReasonOptions: [
      {
        value: "price",
        label: formatMessage({
          id: "price",
          defaultMessage: "Prezzo",
        }),
      },
      {
        value: "missing_in_geniuslab",
        label: formatMessage({
          id: "missing_in_geniuslab",
          defaultMessage: "Mancanza del sistema",
        }),
      },
      {
        value: "different_sell_channel",
        label: formatMessage({
          id: "different_sell_channel",
          defaultMessage: "Canale di vendita diverso",
        }),
      },
      {
        value: "material",
        label: formatMessage({
          id: "material",
          defaultMessage: "Disponibilità materiale",
        }),
      },
      {
        value: "difficult_to_apply",
        label: formatMessage({
          id: "difficult_to_apply",
          defaultMessage: "Difficoltà applicazione",
        }),
      },
      {
        value: "other_brand_fidelity",
        label: formatMessage({
          id: "other_brand_fidelity",
          defaultMessage: "Fedeltà ad altri brand",
        }),
      },
      {
        value: "missing_certifications",
        label: formatMessage({
          id: "missing_certifications",
          defaultMessage: "Mancanza certificazioni",
        }),
      },
      {
        value: "other",
        label: formatMessage({
          id: "other",
          defaultMessage: "Altro",
        }),
      },
    ],
  };
}
